import * as React from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'

import { observer } from 'mobx-react'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { dateToString } from 'modules/core/lib/dates'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import TimeInsightsSidepanel from 'modules/shift_management/components/ShiftManagement/TimeInsightsSidepanel'
import { useSchedule } from 'modules/shift_management/hooks/useSchedule'

const InsightsSidepanelComponent = () => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const [{ view }] = useSchedule()
  const [searchParams] = useSearchParams()

  const dateFrom = dateToString(view.firstDay.clone().startOf('year'), 'backend')
  const dateTo = dateToString(view.firstDay.clone().endOf('year'), 'backend')

  const locationsIds: number[] = searchParams.getAll('locationsIds').map(Number)
  const teamsIds: number[] = searchParams.getAll('teamsIds').map(Number)

  const onCloseSidepanel = () => {
    navigate(
      navigation.shifts.customViewGroup.fullPath({
        viewType: view.viewType,
        groupType: view.groupType,
        year: view.startRangeYear,
        month: view.startRangeMonth,
        day: view.startRangeDay,
      })
    )
  }

  return (
    <ResponsivePage.Body>
      <TimeInsightsSidepanel
        onClose={onCloseSidepanel}
        dateFrom={dateFrom}
        dateTo={dateTo}
        locationsIds={locationsIds}
        teamsIds={teamsIds}
        open
      />
    </ResponsivePage.Body>
  )
}

const InsightsSidepanel = observer(InsightsSidepanelComponent)

export default InsightsSidepanel
